// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type OwnerPlannerFragment = { __typename?: 'OwnerPlannerDTO', id: number, ownerId: number, visibilityDays: number | null, roomOrderOnPlanner: number | null, showAvailableRooms: boolean, showStay: boolean, showRoomPreparation: boolean, showHousekeepingStatus: boolean, showDamages: boolean, hoursOperatorMandatory: boolean, openHour: number | null, closeHour: number | null, calendarRed: number | null, calendarGreen: number | null, calendarBlue: number | null, firstColumnRed: number | null, firstColumnGreen: number | null, firstColumnBlue: number | null, saturdayRed: number | null, saturdayGreen: number | null, saturdayBlue: number | null, sundayRed: number | null, sundayGreen: number | null, sundayBlue: number | null, todayRed: number | null, todayGreen: number | null, todayBlue: number | null, saturdayHeaderRed: number | null, saturdayHeaderGreen: number | null, saturdayHeaderBlue: number | null, sundayHeaderRed: number | null, sundayHeaderGreen: number | null, sundayHeaderBlue: number | null, todayHeaderRed: number | null, todayHeaderGreen: number | null, todayHeaderBlue: number | null, defaultReservationRed: number | null, defaultReservationGreen: number | null, defaultReservationBlue: number | null, checkInReservationRed: number | null, checkInReservationGreen: number | null, checkInReservationBlue: number | null, arrivingReservationRed: number | null, arrivingReservationGreen: number | null, arrivingReservationBlue: number | null, borderIfRoomChange: boolean, boldIfDifferentStay: boolean };

export const OwnerPlannerFragment = gql`
    fragment OwnerPlanner on OwnerPlannerDTO {
  id
  ownerId
  visibilityDays
  roomOrderOnPlanner
  showAvailableRooms
  showStay
  showRoomPreparation
  showHousekeepingStatus
  showDamages
  hoursOperatorMandatory
  openHour
  closeHour
  calendarRed
  calendarGreen
  calendarBlue
  firstColumnRed
  firstColumnGreen
  firstColumnBlue
  saturdayRed
  saturdayGreen
  saturdayBlue
  sundayRed
  sundayGreen
  sundayBlue
  todayRed
  todayGreen
  todayBlue
  saturdayHeaderRed
  saturdayHeaderGreen
  saturdayHeaderBlue
  sundayHeaderRed
  sundayHeaderGreen
  sundayHeaderBlue
  todayHeaderRed
  todayHeaderGreen
  todayHeaderBlue
  defaultReservationRed
  defaultReservationGreen
  defaultReservationBlue
  checkInReservationRed
  checkInReservationGreen
  checkInReservationBlue
  arrivingReservationRed
  arrivingReservationGreen
  arrivingReservationBlue
  borderIfRoomChange
  boldIfDifferentStay
}
    `;
/* eslint-enable */